import "core-js/stable";
import "regenerator-runtime/runtime";
import React, { Component } from "react";
import { Provider } from "react-redux";
import { HashRouter as Router, Route, Switch } from "react-router-dom";

//react-queries
import { ReactQueryDevtools } from "react-query/devtools";
import { QueryClient, QueryClientProvider } from "react-query";

//Redux
import { AUTHENTICATED } from "./actions/authActions";
import store from "./store";

//HOC
import requireAuth from "./hoc/require_auth";
import noRequireAuth from "./hoc/no_require_auth";

// Styles
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import "./styles/scss/style.scss";
// Temp fix for reactstrap
import "./styles/scss/core/_dropdown-menu-right.scss";

// Containers
import Main from "./containers/Main";

// Views Auth
import Signin from "./views/Auth/Signin";

import SelfRegistration from "./views/Student/StudentSelfRegistration";
import RequestResetPassword from "./views/ResetPassword/RequestResetPassword";
import UpdatePassword from "./views/ResetPassword/UpdatePassword";
import PasswordResetAppRedirect from "./views/AppRedirect/PasswordResetAppRedirect";

import { ToastContainer } from "react-toastify";
// Views

import CacheBuster from "react-cache-buster";
import pkg from "../package.json";
import Pacmanloader from "../src/components/Pacmanloader/Pacmanloader";

//const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
/* eslint-disable no-underscore-dangle */
// const store = createStoreWithMiddleware(reducers, /* preloadedState, */
//     window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
/* eslint-enable */

const token = localStorage.getItem("token");

const queryClient = new QueryClient();

library.add(fas);

const App = () => {
  return (
    <CacheBuster
      currentVersion={pkg.version}
      isEnabled={true} //If false, the library is disabled.
      isVerboseMode={false} //If true, the library writes verbose logs to console.
      loadingComponent={<Pacmanloader />} //If not pass, nothing appears at the time of new version check.
    >
      <AppOriginal />
    </CacheBuster>
  );
};

class AppOriginal extends Component {
  componentDidMount() {
    if (token) {
      var jwtDecode = require("jwt-decode");
      var tfix = jwtDecode(token);
      var keys = Object.values(tfix);
      var roles = [];
      roles = keys[3];
      store.dispatch({ type: AUTHENTICATED, payload: { roles: roles } });
    }
  }

  render() {
    return (
      <div>
        <QueryClientProvider client={queryClient}>
          <ToastContainer
            autoClose={3000}
            newestOnTop
            closeOnClick
            pauseOnVisibilityChange
            pauseOnHover
            position="bottom-right"
          />
          <Provider store={store}>
            <Router>
              <Switch>
                <Route
                  exact
                  path="/selfregistration"
                  name="Update Information"
                  component={noRequireAuth(SelfRegistration)}
                />
                <Route
                  exact
                  path="/login"
                  name="Login Page"
                  component={noRequireAuth(Signin)}
                />
                <Route
                  exact
                  path="/password/reset"
                  name="Reset Password"
                  component={noRequireAuth(RequestResetPassword)}
                />
                <Route
                  exact
                  path="/password/update"
                  name="Update Password"
                  component={noRequireAuth(UpdatePassword)}
                />
                <Route
                  exact
                  path="/password/redirectToApp"
                  name="Redirect"
                  component={noRequireAuth(PasswordResetAppRedirect)}
                />
                <Route path="/" name="Home" component={requireAuth(Main)} />
              </Switch>
            </Router>
          </Provider>
          <ReactQueryDevtools />
        </QueryClientProvider>
      </div>
    );
  }
}

export default App;
